import { render, staticRenderFns } from "./article_transferer.vue?vue&type=template&id=20862198&"
import script from "./article_transferer.vue?vue&type=script&lang=js&"
export * from "./article_transferer.vue?vue&type=script&lang=js&"
import style0 from "./article_transferer.vue?vue&type=style&index=0&id=20862198&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports